/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Warning_5Inputs */



/**
* | output |
* | --- |
* | "Without command and without run feedback, the boiler status is not displayed" |
*
* @param {Boiler_Warning_5Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_warning_5 = /** @type {((inputs?: Boiler_Warning_5Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Warning_5Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Without command and without run feedback, the boiler status is not displayed")
	return /** @type {LocalizedString} */ ("En l'absence de commande et de retour de marche, le status de la chaudière n'est pas affiché")
});